// extracted by mini-css-extract-plugin
export default {"container":"src-pages-SalesChannelProductsConfig-SalesChannelProductAlias-ListPage-Preview-style-module__container--WDSgp"};